import { Subscription } from 'rxjs';
import { Component, inject, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { HisBaseGlobalsService } from '../../service/base/his-base-globals.service';
import { HisSearchService } from '../../../genericsearch/service/his-search.service';

declare const pushMsg: (args?: any) => void;

@Component( {
    selector: 'his-page-option-panel',
    templateUrl: './his-page-option-panel.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )

export class HisPageOptionPanelComponent implements OnInit, OnDestroy {
    hisBaseGlobalsService = inject(HisBaseGlobalsService);
    private hisSearchService = inject(HisSearchService);
    private subscription: Subscription;
    
    // Beinhaltet die Suchkonfigurationsdatei
    // contains search configuration file
    searchConfigFileValue: string | null = null;
    
    ngOnInit(): void {
        
        // Abo auf den aktuellen Wert der Suchkonfigurationsdatei.
        // Subscribe to value of search configuration
        this.subscription = this.hisSearchService.subjectSearchConfigurationValueChanged.subscribe((searchConfig:string) => {
            this.updateSearchConfigurationLink(searchConfig);
        });
    }
    
    ngOnDestroy() : void {
        // Abo entfernen.
        this.subscription.unsubscribe();
    }
    
    /* Ruft in Datei "headerHISinOnePortal.xhtml" ein pf:remoteCommand auf, um die Suchkonfigurationsdatei
	 * zum "genericSearchController" zu übergeben.
     * Danach wird automatisch das Overlay geöffnet, um die Suchkonfigurationsdatei herunterzuladen oder
     * den Inhalt in die Zwischenablage zu kopieren.
     * 
     * Inside headerHISinOnePortal.xhtml file, a pf:remoteCommand is called to pass the search configuration
     * file to the genericSearchController.
     * Afterwards, an overlay automatically opens, allowing the user to either download the configuration file
     * or copy its contents to the clipboard.
	 */
    sendSearchConfigFileToJsf() {
	    pushMsg([{ name: 'searchConfigFileValue', value: this.searchConfigFileValue }]);
    }
    
    /*
     * Callback-Funktion, um die Suchkonfigurationsdatei zu aktualisieren.
     * callback-function to update search configuration
     */
    updateSearchConfigurationLink(searchConfig: string) {
        this.searchConfigFileValue = searchConfig;
    }
	
}